import { tableDateFormat } from '../../helpers/dates';
import formatCurrency from '../../helpers/formatCurrency';
import i18n from '../../i18n';

export const cmtplCascoColumns = [
  {
    title: 'insuranceList.contractNumber',
    property: 'masysId',
    sortable: true,
  },
  {
    title: 'insuranceList.from',
    property: 'contractStart',
    sortable: true,
    format: tableDateFormat,
  },
  {
    title: 'insuranceList.to',
    property: 'contractEnd',
    sortable: true,
    format: tableDateFormat,
  },
  {
    title: 'insurance.RegistrationNumb',
    property: 'plateNumber',
    sortable: true,
  },
  {
    title: 'insurance.mark',
    property: 'model',
    sortable: true,
  },
  {
    title: 'insuranceList.price',
    property: 'price',
    sortable: true,
    format: (v) => `${formatCurrency(v)} ${i18n.t('currency.AMD')}`,
  },
];
